import Vue from 'vue'
import Vuex from 'vuex'
import bigScreen from './modules/bigScreen'
import rank from './modules/rank'
let saveUser = localStorage.getItem('userInfo')
let userInfo = saveUser?JSON.parse(saveUser):{};

Vue.use(Vuex);

import api from "../utils/api"
// import { login, regionList } from "../utils/api"
// let { login, regionList } = require("../utils/api")

const store = new Vuex.Store({
	modules: {
		rank //排行榜
	},
	// getters,
	state: {
		userInfo: userInfo,
		// tableDataLength: 0,     // 表格数据总条数
	},
	mutations: {
	},
	actions: {
	},
	getters: {
	}
});

export default store


// WEBPACK FOOTER //
// ./src/store/index.js